import { Modal } from '../Modal/Modal'
import { Button } from '../Button/Button'
import { LinkButton } from '../Button/LinkButton'
import { Modal as BootstrapModal, Stack } from 'react-bootstrap'

interface ZoomOBFWarningModalProps {
  zoomNotConnected: boolean
  show: boolean
  onHide: () => void
}

export const ZoomOBFWarningModal: React.FC<ZoomOBFWarningModalProps> = ({ zoomNotConnected, show, onHide }) => {
  return (
    <Modal
      className='zoom-obf-warning-modal'
      size='lg'
      show={show}
      onHide={onHide}
      header={
        <BootstrapModal.Title className='w-100 d-flex align-items-center justify-content-start'>
          {zoomNotConnected ? 'Keep your AI Assistant working in Zoom meetings' : 'Reconnect Zoom'}
        </BootstrapModal.Title>
      }
      body={
        <div className='d-flex flex-column gap-4'>
          <Stack gap={2}>
            <h6>{zoomNotConnected ? 'Why is this required?' : 'Why reconnection is required?'}</h6>
            <p className='mb-0'>
              {!zoomNotConnected ? 'Your Zoom integration has expired. Additionally ' : ''}Zoom's updated policy requires app integration for services that join
              meetings. This is a Zoom policy change, not a Zocks update.
            </p>
          </Stack>
          <Stack gap={2}>
            <h6>What happens without the integration?</h6>
            <ul className='list-unstyled mb-0'>
              <li className='d-flex gap-2 medium'>
                <i className='bi bi-x-circle zocks-text-danger' />
                Your AI Assistant can't join any Zoom meetings
              </li>
              <li className='d-flex gap-2 medium'>
                <i className='bi bi-x-circle zocks-text-danger' />
                No meeting notes, transcripts, or insights
              </li>
            </ul>
          </Stack>
          <Stack gap={2}>
            <h6>What you need to do</h6>
            <p className='mb-0'>
              {zoomNotConnected ? 'Connect' : 'Reconnect'} the Zoom integration to maintain meeting coverage. This one-time setup takes under 2 minutes.
            </p>
          </Stack>
        </div>
      }
      bodyClassName='p-4'
      footer={
        <div className='d-flex gap-2 w-100'>
          <LinkButton
            variant='link'
            to='https://help.zocks.io/en/articles/9196497-how-to-integrate-zocks-with-meeting-providers'
            target='_blank'
            rel='noopener noreferrer'
            className='zocks-text-primary button-medium text-decoration-none flex-grow-1 text-start justify-content-start'
          >
            Learn more in Help Center
          </LinkButton>
          <Button variant='secondary' onClick={onHide}>
            Cancel
          </Button>
          <LinkButton variant='primary' to='/account/integration-settings/integrations/zoom'>
            {zoomNotConnected ? 'Connect' : 'Reconnect'} Zoom
          </LinkButton>
        </div>
      }
      footerClassName='p-4 pt-0'
    ></Modal>
  )
}
